// extracted by mini-css-extract-plugin
export var dataCell = "_pt-2";
export var dataRow = "_pt-0";
export var headerRow = "_pt-1";